function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Iverify = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.19 1.36L4.19 4.47C3.47 4.79 3 5.51 3 6.3V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V6.3C21 5.51 20.53 4.79 19.81 4.47L12.81 1.36C12.3 1.13 11.7 1.13 11.19 1.36ZM9.29021 16.2901L6.70021 13.7001C6.31021 13.3101 6.31021 12.6801 6.70021 12.2901C7.09021 11.9001 7.72021 11.9001 8.11021 12.2901L10.0002 14.1701L15.8802 8.29006C16.2702 7.90006 16.9002 7.90006 17.2902 8.29006C17.6802 8.68006 17.6802 9.31006 17.2902 9.70006L10.7002 16.2901C10.3202 16.6801 9.68021 16.6801 9.29021 16.2901Z",
    fill: "#495057"
  }));
});